<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('loadingDate') }" class="colStyle">
      {{ items.loadingDate }}
    </div>
    <div v-bind:style="{ width: getWidth('storage.name') }" class="colStyle">
      {{ items.storage.name }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle">
      {{ getUserName(items.user) }}
    </div>
    <div
      v-bind:style="{ width: getWidth('order.supplierId') }"
      class="colStyle"
    >
      {{ getSupplierName(items.order) }}
    </div>

    <!-- ステータス -->
    <div class="yCenter font-weight-bold">
      <NormalButton
        :text="$t('loading.loading_loading-adjust')"
        height="32px"
        color="white"
        textColor="thinText--text"
        class="pa-2 mx-3"
        :outlined="true"
        @click="quickFix.dialog.dialog = true"
        :disabled="isCancel"
      />
      <QuickFixLoadingDialog
        v-model="quickFix.dialog"
        :text="$t('loading.loading_loading-adjust')"
        width="80%"
        :recItems="items"
        :pageInfoData="quickFix.pageInfoData"
      />

      <NormalButton
        v-if="authority.isAdmin"
        :text="$t('loading.loading_loading-cancel')"
        height="32px"
        color="white"
        textColor="thinText--text"
        class="pa-2 mr-2"
        :outlined="true"
        @click="cancel(items.loadingId)"
        :disabled="isCancel"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { orderUtil } from '@/util'

import NormalButton from '@/components/items/Buttons/NormalButton'
import { QuickFixLoadingDialog } from '@/components/layouts/Dialogs'

import { loadingStatusHistory } from '@/config'

export default {
  components: {
    NormalButton,
    QuickFixLoadingDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    isCancel: false,

    quickFix: {
      dialog: {
        dialog: false
      },
      pageInfoData: {}
    },
    complete: {
      dialog: {
        dialog: false,
        date: ''
      }
    },
    ship: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    payment: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    }
  }),
  methods: {
    ...mapActions('Loading', ['cancelLoading']),
    ini() {
      this.isCancel =
        this.items.status === loadingStatusHistory.LOADING_STATUS.CANCEL

      this.quickFix.pageInfoData = {
        line1: {
          controlNumber: this.items.transaction.controlNumber,
          spplierName: this.getSupplierName(this.items.order),
          storageName: this.items.storage.name,
          loadingDate: this.items.loadingDate,
          remarks: {
            data: this.items.loadingNote ? this.items.loadingNote.body : '',
            title: '',
            text: ''
          }
        }
      }
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getSupplierName(order) {
      return orderUtil.getSupplierDisplayName(order)
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    async cancel(loadingId) {
      const isConfirmed = confirm(`
${this.$t('loading.loading_loading-cancel-confirm')}

${this.$t('loading.loading_target-order-number')}:${
        this.items.transaction.controlNumber
      }
${this.$t('loading.loading_loading-number')}: ${
        this.items.order.transaction.controlNumber
      }
${this.$t('order.order_supplier-name')}: ${this.getSupplierName(
        this.items.order
      )}

${this.$t('order.order_irreversible-confirm')}`)

      if (!isConfirmed) return

      const isSucceed = await this.cancelLoading({ id: loadingId })
      if (isSucceed) {
        alert(this.$t('common.common_canceled-alert'))
      }
    }
  },
  created() {
    this.ini()
  },

  computed: {
    ...mapGetters('User', ['authority'])
  }
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
</style>
